module.exports = fox._r("images/promo/tutorial/02.png", __webpack_public_path__ + "_/common/images/promo/tutorial/02.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/02.png
// module id = 651
// module chunks = 2